import React from 'react';
import i18next from 'i18next';
import moment from 'moment';
import { withTranslation } from 'react-i18next';

import { withStyles } from '@material-ui/styles';

import {
  makeRowColumn,
  makeHeadData,
  getHeadObj,
  getFormat,
} from 'lib/commonLib';
import {
  modifyPointLog,
  salesData,
  salesStatistics,
  payTypeList,
  payTypeTot,
} from 'lib/api/sales';

import UsersFilterSelectboxes from 'pages/Main/Users/UsersFilterSelectboxes';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import BasicTable from 'components/molecules/MbBasicTable';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import PayTypeSelectBox from './PayTypeSelectBox';
import RevenuePointTextBox from './RevenuePointTextBox';
import ModifyOutlinedButton from './ModifyOutlinedButton';
import PayTypeFilterBox from './PayTypeFilterBox';

const style = (theme) => ({});
let filterList = [];

const getFilterList = () => {
  payTypeList()
    .then((response) => {
      const { data } = response.data;
      filterList = data;
    })
    .catch((error) => {
      console.log(error);
    });
};

const TotHeadList = [
  {
    id: 'CREDIT_CARD',
    label: i18next.t('신용카드 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'VIRTUAL_ACCOUNT',
    label: i18next.t('가상계좌 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'BANK_DEPOSIT',
    label: i18next.t('무통장 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'POST_PAY',
    label: i18next.t('후불 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'REFUND_POINT',
    label: i18next.t('환불 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'TOT_POINT',
    label: i18next.t('총 합계'),
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
];

const RevenueHeadList = [
  {
    id: 'CUR_REVENUE_RATE',
    label: moment().format('MM') + i18next.t('월 달성률'),
    orderFlag: false,
    type: 'number',
    format: '0.00%',
    displayFlag: true,
  },
  {
    id: 'VAT_LABEL',
    label: '',
    orderFlag: false,
    type: 'string',
    format: '@',
    displayFlag: true,
  },
  {
    id: 'FRPAY_AMT',
    label: i18next.t('후불매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'CUR_REVENUE',
    label: i18next.t('현재달성매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAX_TARGET_REVENUE',
    label: i18next.t('최대목표매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAX_WORK_REVENUE',
    label: i18next.t('최대일할매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MIN_TARGET_REVENUE',
    label: i18next.t('최소목표매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MIN_WORK_REVENUE',
    label: i18next.t('최소일할매출'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
];

const headList = [
  {
    id: 'LABEL',
    label: i18next.t('월별사용내역'),
    orderFlag: false,
    type: 'string',
    format: '@',
    displayFlag: true,
  },
  {
    id: 'JAN',
    label: i18next.t('1월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'FEB',
    label: i18next.t('2월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAR',
    label: i18next.t('3월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'APR',
    label: i18next.t('4월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'MAY',
    label: i18next.t('5월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'JUN',
    label: i18next.t('6월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'JUL',
    label: i18next.t('7월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'AUG',
    label: i18next.t('8월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'SEP',
    label: i18next.t('9월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'OCT',
    label: i18next.t('10월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'NOV',
    label: i18next.t('11월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
  {
    id: 'DEC',
    label: i18next.t('12월'),
    orderFlag: false,
    type: 'number',
    format: '#,##0',
    displayFlag: true,
  },
];

const totCustomized = {};

const customized = {};

const revenueCustomized = {
  CUR_REVENUE_RATE: {
    makeHead: (headsMap) => {
      return `${getHeadObj(headsMap, 'CUR_REVENUE_RATE').label}`;
    },
    makeBody: (rowObj, headsMap) => {
      const curRevenueRate = getHeadObj(headsMap, 'CUR_REVENUE_RATE');
      let content;
      if (rowObj['CUR_REVENUE_RATE'] !== '') {
        content = (
          <>
            <div
              style={{
                backgroundColor: '#fff',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  backgroundColor: '#fff',
                  fontWeight: 'bold',
                  fontSize: 20,
                  color: 'red',
                }}
              >
                {makeRowColumn(
                  rowObj['CUR_REVENUE_RATE'],
                  curRevenueRate.type,
                  curRevenueRate.format
                )}
              </div>
            </div>
          </>
        );
      } else {
        content = '';
      }
      return content;
    },
  },
};

let initialization = false;
let initParam = {
  sDate: moment().format('YYYYMMDD'),
  eDate: moment().format('YYYYMMDD'),
};

class Statistics extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      params: initParam,
      payTypeArray: [],
      modifyParams: [],
      list: [],
      revenueList: [],
      infoMessage: '',
      listCustomized: {
        SPNAME: {
          merged: true,
        },
        PNAME: {
          checkFlag: true,
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'PNAME').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            const pname = getHeadObj(headsMap, 'PNAME');

            return (
              <>
                <span title={rowObj['PNAME']}>
                  {makeRowColumn(rowObj['SPNAME'], pname.type, pname.format)}
                </span>
              </>
            );
          },
        },
        PAY_DESC: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'PAY_DESC').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = '';
            } else {
              let codeId;
              for (let i = 0; i < filterList.length; i++) {
                if (rowObj['PAY_TYPE'] === filterList[i].CODE_ID) {
                  codeId = i;
                  break;
                }
              }
              content = (
                <>
                  <div>
                    <PayTypeSelectBox
                      initialization={initialization}
                      filterList={filterList}
                      defaultCodeId={codeId}
                      label={'결제유형'}
                      orderNumber={rowObj['ORDER_NUMBER']}
                      handleOnchangeFilter={this.handleOnchangeSelectParams}
                    ></PayTypeSelectBox>
                  </div>
                </>
              );
            }

            return content;
          },
        },
        PAY_TYPE: {
          merged: true,
        },
        REVENUE_POINT: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'REVENUE_POINT').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            const revenuePoint = getHeadObj(headsMap, 'REVENUE_POINT');
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = (
                <>
                  {makeRowColumn(
                    rowObj['REVENUE_POINT'],
                    revenuePoint.type,
                    revenuePoint.format
                  )}
                </>
              );
            } else {
              content = (
                <>
                  <div>
                    <RevenuePointTextBox
                      defaultValue={rowObj['REVENUE_POINT']}
                      orderNumber={rowObj['ORDER_NUMBER']}
                      paramsKey={'revenuePoint'}
                      handleOnBlurText={this.handleOnchangeTextParams}
                      hasIcon={true}
                    ></RevenuePointTextBox>
                  </div>
                </>
              );
            }

            return content;
          },
        },
        DEPOSITOR: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'DEPOSITOR').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = <></>;
            } else {
              let depositor = rowObj['DEPOSITOR'];
              if (depositor === null) depositor = '';
              content = (
                <>
                  <div style={{ float: 'left' }}>
                    <RevenuePointTextBox
                      defaultValue={depositor}
                      orderNumber={rowObj['ORDER_NUMBER']}
                      paramsKey={'depositor'}
                      handleOnBlurText={this.handleOnchangeTextParams}
                    ></RevenuePointTextBox>
                  </div>
                </>
              );
            }

            return content;
          },
        },
        MEMO: {
          makeHead: (headsMap) => {
            return `${getHeadObj(headsMap, 'MEMO').label}`;
          },
          makeBody: (rowObj, headsMap) => {
            let content;
            if (rowObj['STATS_DTTM'] === 'total') {
              content = <></>;
            } else {
              let memo = rowObj['MEMO'];
              if (memo === null) memo = '';
              content = (
                <>
                  <div style={{ float: 'left' }}>
                    <RevenuePointTextBox
                      defaultValue={memo}
                      orderNumber={rowObj['ORDER_NUMBER']}
                      paramsKey={'memo'}
                      handleOnBlurText={this.handleOnchangeTextParams}
                    ></RevenuePointTextBox>
                  </div>
                  <div style={{ float: 'left' }}>
                    <ModifyOutlinedButton
                      modifyClick={this.modifyOnClick}
                      orderNumber={rowObj['ORDER_NUMBER']}
                    ></ModifyOutlinedButton>
                  </div>
                </>
              );
            }

            return content;
          },
        },
        ORDER_NUMBER: {
          merged: true,
        },
      },
      loading: false,
    };
  }

  modifyOnClick = (orderNumber) => {
    const { modifyParams } = this.state;

    if (typeof modifyParams[orderNumber] !== 'undefined') {
      modifyPointLog(
        orderNumber,
        modifyParams[orderNumber].depositor,
        modifyParams[orderNumber].revenuePoint,
        modifyParams[orderNumber].payType,
        modifyParams[orderNumber].memo
      )
        .then((response) => {
          const data = response.data;
          alert(data.message);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  handleOnClickFilter = (payTypeArray, value, checked) => {
    const { params } = this.state;
    let checkedStr;

    let newPayTypeArray = payTypeArray;
    if (checked) {
      newPayTypeArray.push(value);
    } else {
      const idx = newPayTypeArray.indexOf(value);
      if (idx > -1) newPayTypeArray.splice(idx, 1);
    }

    checkedStr = newPayTypeArray.join(',');
    this.setState({
      ...this.state,
      params: { ...params, payType: checkedStr },
      payTypeArray: newPayTypeArray,
    });
  };

  handleOnchangeTextParams = (orderNumber, value, paramsKey) => {
    const { modifyParams } = this.state;
    if (typeof modifyParams[orderNumber] === 'undefined') {
      modifyParams[orderNumber] = [];
    }
    modifyParams[orderNumber][paramsKey] = value;

    this.setState({
      ...this.state,
      modifyParams: modifyParams,
    });
  };

  handleOnchangeSelectParams = (orderNumber, selectedIndex) => {
    const { modifyParams } = this.state;
    modifyParams[orderNumber] = {
      payType: filterList[selectedIndex].CODE_ID,
    };
    this.setState({
      ...this.state,
      modifyParams: modifyParams,
    });
  };

  getListData = () => {
    salesData({ year: moment().format('YYYY') })
      .then((response) => {
        const { data } = response.data;
        const yearDatas = data.yearDatas;
        const revenueDatas = data.revenueDatas;

        this.setState({
          ...this.state,
          list: yearDatas,
          revenueList: revenueDatas,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          moreFetching: false,
          error: true,
        });
      });
  };

  getData = () => {
    const { params } = this.state;
    const { t, locale } = this.props;
    const { sDate, eDate } = params;
    const format = getFormat(locale);
    this.setState({
      ...this.state,
      loading: true,
      error: false,
      infoMessage: t('까지의 통계 데이터입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      }),
    });

    payTypeTot({ sDate: sDate, eDate: eDate })
      .then((response) => {
        const { data } = response.data;

        this.setState({
          ...this.state,
          totList: data,
        });
      })
      .catch((error) => {
        this.setState({
          ...this.state,
          moreFetching: false,
          error: true,
        });
      });
  };

  componentDidMount() {
    getFilterList();
    this.getListData();
    this.getData();
  }

  componentDidUpdate(prevState) {
    // const { params: prevParams } = prevState;
    // const { params } = this.state;
  }

  /**
   * 필터 선택 관련
   */
  handleOnchangeFilter = (filterParam) => {
    const { params } = this.state;
    this.setState({
      ...this.state,
      params: { ...params, ...filterParam },
    });
  };

  /**
   * 필터 초기화
   */
  handleOnReset = () => {
    initialization = true;

    this.setState({
      ...this.state,
      params: { ...initParam },
    });
  };

  getParam = (newParams) => {
    const { getInitParam } = this.state;

    initialization = false;
    if (getInitParam === false) {
      initParam = {
        ...initParam,
        ...newParams,
      };
    }

    this.getData();

    this.setState({
      ...this.state,
      getInitParam: true,
      params: {
        ...this.state.params,
        ...newParams,
      },
    });
  };

  render() {
    const {
      handleOnClickFilter,
      handleOnchangeFilter,
      handleOnReset,
      getParam,
    } = this;
    const { classes, t } = this.props;
    const {
      params,
      listCustomized,
      payTypeArray,
      loading,
      list,
      revenueList,
      totList,
      infoMessage,
      getInitParam,
    } = this.state;

    const revenueInfoMessage = t('년도 모비온 매출내역', {
      year: moment().format('YYYY'),
    });

    return (
      <>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('매출관리')}
                tooltipTitle={revenueInfoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
        >
          <div>
            {list && (
              <BasicTable
                list={list}
                sort={'asc'}
                order={'LABEL'}
                headCells={makeHeadData(headList)}
                loading={loading}
                customized={customized}
              />
            )}
          </div>
          <div style={{ marginTop: 20 }}>
            {revenueList && (
              <BasicTable
                list={revenueList}
                sort={'asc'}
                order={'LABEL'}
                headCells={makeHeadData(RevenueHeadList)}
                loading={loading}
                customized={revenueCustomized}
              />
            )}
          </div>
        </SwitchingArea>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('합계')}
                tooltipTitle={infoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
        >
          <div style={{ marginTop: 20 }}>
            {totList && (
              <BasicTable
                list={totList}
                sort={'asc'}
                order={'LABEL'}
                headCells={makeHeadData(TotHeadList)}
                loading={loading}
                customized={totCustomized}
              />
            )}
          </div>
        </SwitchingArea>
        <SwitchingArea
          title={
            <>
              <InfoTitleArea
                title={t('매출내역')}
                tooltipTitle={infoMessage}
                iconType="fainfoCircle"
                iconColor="graph"
              />
            </>
          }
        >
          <FilterWrap handleOnReset={handleOnReset}>
            <StatisticsCommonFilter
              initialization={initialization}
              getParam={getParam}
              initData={initParam}
              nonePltfomTpCodeFilter={true}
              noneDisplayFilter={true}
              noneExternalFilter={true}
              displayFilterList={true}
            />
            <UsersFilterSelectboxes
              initialization={initialization}
              handleOnchangeFilter={handleOnchangeFilter}
            />
            {filterList.length !== 0 && (
              <PayTypeFilterBox
                filterList={filterList}
                filterArray={payTypeArray}
                handleOnClickFilter={handleOnClickFilter}
                label={t('결제유형')}
              ></PayTypeFilterBox>
            )}
          </FilterWrap>
          {getInitParam && (
            <>
              <TableContainer
                className={classes.root}
                dataReqPromise={salesStatistics}
                params={{ ...params }}
                sort="desc"
                order="STATS_DTTM"
                dense={true}
                customized={listCustomized}
                hasExcel
                hasTotal
                noneSearch
              />
            </>
          )}
        </SwitchingArea>
      </>
    );
  }
}

export default withTranslation()(withStyles(style)(Statistics));
